// extracted by mini-css-extract-plugin
module.exports = {"projects":"Projects_projects__h1fYA","cards":"Projects_cards__d1WYr","text":"Projects_text__vQeCQ","title":"Projects_title__Aptkl","desc":"Projects_desc__pZBKw"};